import { format } from "date-fns";
import moment from "moment";

export const renderPageImage = (file) => {
  let src;
  if (typeof file === "object") {
    src = URL.createObjectURL(file);
  }
  if (typeof file === "string") {
    src = file;
  }
  return src;
};

export const validatePageImage = (file) => {
  let isValid = false;

  if (file !== null && file !== "") {
    isValid = true;
  }

  return isValid;
};

export const convertToBoolean = (value) => {
  let bool = false;
  bool = value?.toLowerCase?.() === "true" || value === true;
  return bool;
};

export const validateEmail = (input) => {
  var validRegex =
    /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/;
  let valid = false;

  if (input.match(validRegex)) {
    valid = true;
  }

  return valid;
};

export const displayAddresses = (data) => {
  return [
    data?.address_1,
    data?.address_2,
    data?.address_3,
    data?.address_4,
    data?.city,
    data?.postcode,
    data?.county,
    data?.country,
  ]
    .filter((x) => !!x && x !== "''")
    .join("\n");
};

export const displayCardAddress = (data) => {
  let address = "";
  address = `${data?.city}`;
  if (data?.postcode) {
    address = `${address}, ${data?.postcode}`;
  }
  if (data?.company_details?.name) {
    address = `${address} - ${data?.company_details?.name}`;
  }
  return address;
};

export const populateList = (user) => {
  let list = [];
  if (user?.accounting_type === "manager") {
    list =
      user.location.filter((item) => {
        return user.manage_location.some((manageItem) => {
          return manageItem.location_id === item.id;
        });
      }) ?? [];
  } else {
    list = user?.location ?? [];
  }
  return list;
};

const download = (data) => {
  const csvContent = `data:text/csv;charset=utf-8,${data}`;
  const encodedURI = encodeURI(csvContent);
  window.open(encodedURI);
};

export function lcFirst(string) {
  if (!(typeof string !== "string")) {
    return "";
  }

  if (string.length === 0) {
    return string;
  }

  return string[0].toLowerCase() + string.slice(1);
}

export function generateYearsBetween(startYear = 2000, endYear) {
  const endDate = endYear || new Date().getFullYear();
  let years = [];

  for (var i = startYear; i <= endDate; i++) {
    years.push(startYear);
    startYear++;
  }
  return years;
}

export function validateDot(data) {
  let validation = {
    can_show: false,
    color: "",
  };

  if (
    data?.updated_at?.includes("hour") ||
    data?.updated_at?.includes("second") ||
    data?.updated_at?.includes("minute")
  ) {
    validation.can_show = true;
    validation.color = "green";
  } else if (data?.updated_at?.includes("day")) {
    let day = data?.updated_at.match(/\d+/)[0];
    if (parseInt(day) > 5) {
      validation.can_show = true;
      validation.color = "grey";
    } else if (parseInt(day) <= 5) {
      validation.can_show = true;
      validation.color = "green";
    }
  } else {
    validation.can_show = true;
    validation.color = "grey";
  }

  return validation;
}

export function validateActivityDot(data) {
  let validation = {
    can_show: false,
    color: "red",
  };
  if (data?.latest_activity_details?.id) {
    validation.can_show = true;
  }
  return validation;
}

export function capitalizeFirstLetter(string) {
  return string.charAt(0).toUpperCase() + string.slice(1);
}

export const displayName = (data) => {
  return [data?.title, data?.first_name, data?.last_name]
    .filter((x) => !!x && x !== "''")
    .join(" ");
};

export const overwritePerms = (data) => {
  let user = JSON.parse(JSON.stringify(data));

  // Overwrite permissions for master admin
  // if (
  //   user?.accounting_type === "administrator" ||
  //   user?.is_master_admin === true
  // ) {
  //   user.role.access_permissions.map((item) => {
  //     item.permission = "ADMIN";
  //   });
  // }

  // Overwrite permissions for manager
  let defaultRole = [];
  let modifiedPermList = user.permissions ?? [];
  let permissions = ["NO ACCESS", "READ", "DISPLAY", "WRITE", "ADMIN"];

  if (
    user.accounting_type === "manager" &&
    modifiedPermList.length > 0 &&
    defaultRole.length > 0
  ) {
    defaultRole = user.role;
    modifiedPermList.map((item) => {
      let foundPerm = defaultRole.access_permissions.find(
        (ele) => ele.item_id === item.item_details.id,
      );
      let foundPermIndex = defaultRole.access_permissions.indexOf(
        (ele) => ele.item_id === item.item_details.id,
      );
      if (foundPerm?.item_id) {
        foundPerm.permission = permissions[item.permission_id];
      }
    });
  }

  return user;
};

export const isSameOrBefore = (startTime, endTime) => {
  return moment(startTime, "HH:mm").isSameOrBefore(moment(endTime, "HH:mm"));
};

export function removeDuplicates(arr) {
  return arr.filter((item, index) => arr.indexOf(item) === index);
}

export function percentage(value, total) {
  if (value === 0 && total === 0) {
    return 0;
  } else {
    return parseInt((value / total) * 100 ?? 0);
  }
}

export function mintuesToHours(min) {
  var hours = Math.trunc(min / 60);
  var minutes = minutes % 60;
  if (min == 0) {
    return 0;
  } else {
    return `${parseInt(`${hours}.${minutes}`)}`;
  }
}

export const displayShift = (shift) => {
  return `${moment(shift?.shift_date).format(`MMM Do YY`)} from  
  ${moment(shift?.shift_start_time, "hh:mm:ss").format("HH:mm A")} to 
  ${moment(shift?.shift_end_time, "hh:mm:ss").format("HH:mm A")}`;
};

export const displayShiftTime = (shift) => {
  return ` 
  ${moment(shift?.shift_start_time, "hh:mm:ss").format("HH:mm A")} - 
  ${moment(shift?.shift_end_time, "hh:mm:ss").format("HH:mm A")}
  `;
};

export const displayClockTime = (clock) => {
  let start = clock.clockin_time
    ? moment(clock.clockin_time, "hh:mm:ss").format("HH:mm A")
    : "Pending";
  let end = clock.clockout_time
    ? moment(clock.clockout_time, "HH:mm:ss").format("HH:mm A")
    : "Pending";
  return `${start} - ${end}`;
};

export const summaryCoverText = (swap, settings) => {
  let text = ``;
  let from = swap?.swap_from_employee_details;
  let to = swap?.swap_to_employee_details;

  if (
    settings?.must_approved_all_shift ||
    settings?.must_approved_all_shift === 1
  ) {
    if (
      swap?.request_actioned_on !== null &&
      swap?.is_request_accepted === true
    ) {
      text = `${displayName(
        to,
      )} has accepted to cover this shift for you. Please wait for admin approval.`;
      if (swap?.shift_swap_approved_on !== null) {
        if (swap.is_shift_swap_approved == true) {
          text = `Admin approved ${displayName(to)} to cover 
          ${displayName(from)}'s shift.`;
        } else {
          text = `Admin declined the request ${displayName(to)} to cover 
          ${displayName(from)}'s shift.`;
        }
      }
    } else {
      // Rejected by employee
      text = `${displayName(to)} has declined to cover this shift for you.`;
    }
  } else {
    if (swap?.request_actioned_on !== null && !swap?.is_request_accepted) {
      text = `${displayName(to)} has rejected to cover this shift.`;
    } else {
      text = `${displayName(
        to,
      )} has accepted to cover this shift for ${displayName(from)}.`;
    }
  }

  return text;
};
export const summarySwapText = (swap, settings) => {
  let text = ``;
  let from = swap?.swap_from_employee_details;
  let to = swap?.swap_to_employee_details;

  if (
    settings?.must_approved_all_shift ||
    settings?.must_approved_all_shift === 1
  ) {
    // Accepeted by employee
    if (
      swap?.request_actioned_on !== null &&
      swap?.is_request_accepted === true
    ) {
      text = `${displayName(
        to,
      )} has accepted to swap shift. Please wait for admin approval.`;
      if (swap?.shift_swap_approved_on !== null) {
        if (swap.is_shift_swap_approved == true) {
          text = `Admin approved 
          ${displayName(from)} to swap their 
          shift on ${displayShift(from.shift_details)}
          with ${displayName(to)}'s on 
          ${displayShift(to.shift_details)}`;
        } else {
          text = `Admin declined the swap.`;
        }
      }
    } else {
      // Rejected by employee
      text = `${displayName(to)} has rejected to swap`;
    }
  } else {
    if (swap?.request_actioned_on !== null && !swap?.is_request_accepted) {
      text = `${displayName(to)} has rejected to swap shift.`;
    } else {
      text = `${displayName(to)} has accepted to swap with 
      ${displayName(from)}.`;
    }
  }

  return text;
};

export function needsApproval(settings) {
  let needs = false;
  if (settings?.id) {
    if (
      settings?.must_approved_all_shift == true ||
      settings?.must_approved_all_shift == 1
    ) {
      needs = true;
    }
  }
  return needs;
}

export function getSumByKey(arr, key) {
  let sum = 0;
  sum = arr.reduce((n, { key }) => n + key, 0);
  return sum;
}

export const canRenderIcon = (day, type, leaves) => {
  let canRender = false;
  let date = format(day, "yyyy-MM-dd");
  let dateToCheck = `${date} 00:00:00`;
  let list = leaves?.[type] ?? [];
  if (list?.length) {
    list.forEach((leave) => {
      if (
        moment(dateToCheck).isBetween(
          moment(leave.start_date),
          moment(leave.end_date),
          null,
          "[]",
        )
      ) {
        canRender = true;
      }
    });
  }
  return canRender;
};

export const getDateByAdding = (date, addValue, addType) => {
  return moment(date).add(addValue, addType).format(`YYYY-MM-DD`);
};

export const getDateBySubtract = (date, addValue, addType) => {
  return moment(date).subtract(addValue, addType).format(`YYYY-MM-DD`);
};

export const populateDefLocation = (user) => {
  let location = {};
  let defaultLocation = user?.default_location ?? {};
  let locationList = populateList(user);

  if (defaultLocation?.id) {
    location = locationList?.find((x) => x.id === defaultLocation?.id) ?? {};
  }

  return location;
};

export const validateLastPending = (list) => {
  let isPending = false;
  let firstEvent = list[0];
  if (firstEvent?.title === "Reminder_Event" && !firstEvent?.mark_as_done) {
    isPending = true;
  }
  return isPending;
};

export const displayUpdateBy = (data) => {
  return `${data?.first_name ?? ""} ${data?.last_name ?? ""}`;
};

export const displayBreak = (data) => {
  let start = data?.break_start
    ? moment(data?.break_start, "HH:mm:ss").format(`HH:mm A`)
    : "Pending";
  let end = data?.break_end
    ? moment(data?.break_end, "HH:mm:ss").format(`HH:mm A`)
    : "Pending";
  return `${start} - ${end}`;
};

function getHighestPermissionItem(arr) {
  return arr.reduce((highest, current) => {
    return current.permission_id > highest.permission_id ? current : highest;
  });
}

export const isActionAuthorized = (currentItem, requiredPermission, user) => {
  let isAuthorized = false;
  let permissions = ["NO ACCESS", "READ", "DISPLAY", "WRITE", "ADMIN"];
  let userItemPermission = null;
  let list =
    user.permissions.map((ele) => {
      return {
        ...ele.item_details,
        permission: permissions[ele.permission_id],
        permission_id: ele.permission_id,
      };
    }) ?? [];

  if (
    user?.is_master_admin === true ||
    user?.accounting_type === "administrator"
  ) {
    isAuthorized = true;
  } else {
    if (list.length > 0) {
      let allItemPerm =
        list.filter((ele) => ele?.item_name === currentItem) ?? [];

      if (allItemPerm.length > 1) {
        userItemPermission = getHighestPermissionItem(allItemPerm);
      }
      if (allItemPerm.length === 1) {
        userItemPermission = allItemPerm[allItemPerm.length - 1];
      }
    }

    if (
      userItemPermission &&
      permissions.includes(requiredPermission) &&
      permissions.indexOf(requiredPermission) <=
        permissions.indexOf(userItemPermission.permission)
    )
      isAuthorized = true;

    if (
      userItemPermission &&
      !permissions.includes(requiredPermission) &&
      permissions.indexOf(userItemPermission.permission) >= 1
    )
      isAuthorized = true;
  }

  return isAuthorized;
};

export const validateBoolItem = (
  item,
  settings,
  accountType,
  shouldSkipAdminCheck = true,
) => {
  let isValid = false;
  if (accountType === "administrator" && shouldSkipAdminCheck) {
    isValid = true;
  } else {
    if (settings?.id) {
      isValid = item.key.some((key) => settings[key] === true);
    }
  }

  return isValid;
};

export const hasWageAccess = (user, locationId) => {
  const location = user?.location?.find((item) => item.id === locationId);
  return location?.is_wage_configurable;
};

export const allFeedAccess = (location) => {
  if (!location?.length) return false;
  let allLocationsHaveFeed = true;
  location.map((item) => {
    if (
      item?.subscription_package_details?.item_name?.findIndex(
        (ele) => ele.item_name === "FEED",
      ) >= 0
    ) {
      allLocationsHaveFeed = true;
    } else {
      allLocationsHaveFeed = false;
    }
  });
  return allLocationsHaveFeed;
};

export function convertToSlug(str) {
  return str
    .toLowerCase()
    .replace(/\s+/g, "-")
    .replace(/[^\w\-]+/g, "");
}

export function convertToFolderName(slug) {
  return slug.replace(/-/g, " ");
}

export function pathToSlug(path) {
  const folderArray = path.split("/");

  let formattedPath = "";

  folderArray.forEach((folder, index) => {
    if (index === 0) {
      formattedPath += folder.toLowerCase().replace(/ /g, "-") + "";
    } else {
      formattedPath += "/" + folder.toLowerCase().replace(/ /g, "-") + "";
    }
  });

  return formattedPath;
}

export function bytesToKB(bytes) {
  return (bytes / 1024).toFixed(2);
}

export function getFileExtension(filename) {
  const extension = filename.split(".").pop();
  return extension;
}

export function createBreadcrumbs(str) {
  const parts = str.split("/").filter((part) => part !== "");

  let breadcrumbs = [
    {
      name: "Policy",
      path: "/d/policy",
    },
  ];
  let path = "";

  parts.forEach((part) => {
    path += part + "/";
    breadcrumbs.push({
      name: part,
      path: `/d/policy/folder/${path.slice(0, -1)}`,
    });
  });

  return breadcrumbs;
}

export function getKeyFromLabel(label) {
  const key = label
    .toLowerCase()
    .trim()
    .replace(/\s+/g, "_")
    .replace(/[^a-z0-9_]/g, "");

  return key;
}

export function getLabelFromKey(key) {
  return key
    .split("_")
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
    .join(" ");
}

export const displayRequestDate = (leave) => {
  return `${moment(leave.start_date).format("LL")} (${
    leave.start_period
  }) - ${moment(leave.end_date).format("LL")} (${leave.end_period})`;
};

export const displayShiftPeriod = (shift) => {
  const shiftStartHour = moment(shift.shift_start_time, "HH:mm:ss").hour();

  if (shiftStartHour >= 5 && shiftStartHour < 12) {
    return "Morning";
  } else if (shiftStartHour >= 12 && shiftStartHour < 17) {
    return "Afternoon";
  } else if (shiftStartHour >= 17 && shiftStartHour < 22) {
    return "Evening";
  } else {
    return "Night";
  }
};

export const relationList = [
  "Resident / Service User",
  "Respite Resident/Service User",
  "Day Care Service User",
  "Friend of Resident/Service User",
  "Brother of Resident/Service User",
  "Sister of Resident/Service User",
  "Wife of Resident/Service User",
  "Husband of Resident/Service User",
  "Partner of Resident/Service User",
  "Civil Partner of Resident/Service User",
  "Son of Resident/Service User",
  "Daughter of Resident/Service User",
  "Grandson of Resident/Service User",
  "Granddaughter of Resident/Service User",
  "Great-grandson of Resident/Service User",
  "Great-granddaughter of Resident/Service User",
  "Nephew of Resident/Service User",
  "Niece of Resident/Service User",
  "Great-Nephew of Resident/Service User",
  "Great-Niece of Resident/Service User",
  "Great Great-Nephew of Resident/Service User",
  "Great Great-Niece of Resident/Service User",
  "Father of Resident/Service User",
  "Mother of Resident/Service User",
  "Grandfather of Resident/Service User",
  "Grandmother of Resident/Service User",
  "Aunt of Resident/Service User",
  "Uncle of Resident/Service User",
  "Son-in-law of Resident/Service User",
  "Daughter-in-law of Resident/Service User",
  "Father-in-law of Resident/Service User",
  "Mother-in-law of Resident/Service User",
  "Brother-in-law of Resident/Service User",
  "Sister-in-law of Resident/Service User",
  "Stepson of Resident/Service User",
  "Stepdaughter of Resident/Service User",
  "Stepbrother of Resident/Service User",
  "Stepsister of Resident/Service User",
  "Stepfather of Resident/Service User",
  "Stepmother of Resident/Service User",
  "Cousin of Resident/Service User",
  "Widow / Widower",
  "Relative of Resident/Service User",
  "Guardian of Resident/Service User",
  "Godfather of Resident/Service User",
  "Godmother of Resident/Service User",
  "Godson of Resident/Service User",
  "Goddaughter of Resident/Service User",
  "Power of Attorney of Resident/Service User",
  "Ex Family Member",
  "Private Carer of Resident/Service User",
  "IMCA (Independent Mental Capacity Advocate)/Deputyship",
  "Vicar / Church Minister",
  "Solicitor of Resident/Service User",
  "Regular Volunteer",
  "Next of Kin",
];

export const maskString = (input, count) => {
  if (!input) return "";

  const str = input.toString();
  const visibleLength = count ?? 4;
  const maskedLength = Math.max(0, str.length - visibleLength);

  const masked = "*".repeat(maskedLength) + str.slice(-visibleLength);
  return masked;
};

export const displayPipedText = (list) => {
  if (!list || !Array.isArray(list)) return "";
  const capitalizedList = list
    .filter((item) => item && item !== "")
    .map((item) => {
      if (typeof item === "string") {
        return item.charAt(0).toUpperCase() + item.slice(1);
      }
      return item;
    });
  return capitalizedList.join(" | ");
};
